import Component from "../lib/Component";
import Lenis from "@studio-freight/lenis";

export default class SmoothScroll extends Component {
	constructor() {
		super("body");
	}

	initialize() {
		this.initSmoothScrolling();
	}

	// Initialize Lenis smooth scrolling
	initSmoothScrolling() {
		const isAdmin = !document.querySelector("#wpadminbar");

		const lenis = new Lenis({
			smooth: isAdmin
		});
		const scrollFn = (time) => {
			lenis.raf(time);
			requestAnimationFrame(scrollFn);
		};
		requestAnimationFrame(scrollFn);
	}
}
